<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('transfer')">
            <app-default-button class="mr-2"
                :title="$fieldTitle('add', 'transfer', true)"
                v-if="$can('create_finance_transfers')"
                @click="openModal()"
            />
            <!-- <app-default-button class="btn-success"
                :title="$t('account')"
                @click="redirectTo('/finance/accounts')"
            /> -->
        </app-page-top-section>

        <app-table
            id="finance-transfer-table"
            :options="options"
            @action="triggerActions"
        />

        <app-finance-transfer-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('finance-transfer-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import FinanceTransferMixin from "../../Mixins/FinanceTransferMixin";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";

export default {
    name  : "FinanceTransfer",
    mixins: [HelperMixin, FinanceTransferMixin],
    data() {
        return {
            isModalTypeActive: false,
            isModalActive    : false,
            selectedUrl      : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (!row.editable) {
                this.$toastr.e(this.$t('this_record_can_no_longer_be_edited'));
                return;
            }

            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/finance-transfers/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>

<style scoped>
::v-deep .btn-success {
    color: #ffffff !important;
    background-color: #46c35f !important;
    border-color: #46c35f !important;
}

::v-deep .reorder-handle {
    width: 40px;
}

::v-deep .reorder-handle .drag-icon {
    cursor: grab;
    user-select: none;
}

::v-deep .reorder-handle .drag-icon:active {
    cursor: grabbing;
}
</style>
